<template>
  <span>
    {{ translatedType }}
  </span>
</template>

<script>
export default {
  name: 'TransactionsTableStatusColumnContent',
  props: {
    type: {
      type: String,
      required: true,
    },
    amount: {
      type: Number,
      required: true,
    },
  },
  computed: {
    typeTranslationMap() {
      return {
        bankTransfer: this.$t('ADVERTISEMENT.RECEIPT.BANK_TRANSFER'),
        cheque: this.$t('ADVERTISEMENT.RECEIPT.CHEQUE'),
        gateway:
          this.amount > 0
            ? this.$t('ADVERTISEMENT.RECEIPT.GATEWAY')
            : this.$t('ADVERTISEMENT.RECEIPT.GATEWAY_REFUND'),
      };
    },
    translatedType() {
      return this.typeTranslationMap[this.type] || '';
    },
  },
};
</script>
